import { useState } from "react";
import { Button, Modal } from "react-bootstrap"
import { toast } from "react-toastify";
import { SearchFileAPI } from "../../../API/FilesAPI";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { FileModel } from "../../../Models/FileModel";
import { FilesSearchColumns } from "../../../Static/FilesColumns";
import TableDefault from "../../Shared/TableDefault";

interface IModalSearchFileComponentProps {
    show: boolean,
    handleClose: () => void,
    toggleLoading: (data: boolean) => void,
    companyId: string,
    pathMain: string,
}

const ModalSearchFileComponent = (props: IModalSearchFileComponentProps) => {
    const [pathName, setPathName] = useState<string>("");
    const [files, setFiles] = useState<FileModel[]>([]);
    const [total, setTotal] = useState<number>(0);

    const searchFile = async (page?: number) => {
        try {
            props.toggleLoading(true);

            let text = pathName == null || pathName == "" ? "all" : pathName;

            await SearchFileAPI(props.companyId, props.pathMain, page ?? 1, 7, text).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setFiles(resp.data.items);
                    setTotal(resp.data.total);
                }
            }).finally(() => props.toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    const handleClose = () => {
        setFiles([]);
        setPathName("");
        props.handleClose();
    }

    return (
        <Modal show={props.show} size="lg" onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Buscar Arquivos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label className="required">Nome do arquivo:</label>
                <input required value={pathName} onChange={(e) => setPathName(e.target.value)} className="w-100 form-control mt-1" />
                <Button disabled={pathName == ""} className='btn btn-primary w-100 mt-2 mb-2' onClick={() => searchFile()}>
                    Buscar Arquivo
                </Button>
                <TableDefault
                    columns={FilesSearchColumns}
                    hasHeader={true}
                    hasPagination={true}
                    rows={files}
                    lastColumnIsAction={false}
                    isFiles={true}
                    total={total}
                    changePage={searchFile}
                />
            </Modal.Body>
        </Modal>
    )
}

export default ModalSearchFileComponent